import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import CTASection from './components/CTASection';
import JsonLd from '../../components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://devstander.com';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: 'Devstander',
      description: 'High-Standard Software Development Warsaw',
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'Devstander',
      url: `${siteUrl}/`,
      telephone: '+48532004860',
      email: 'info@devstander.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Nowogrodzka 50/54 - 515',
        postalCode: '00-695',
        addressLocality: 'Warsaw',
        addressCountry: 'PL',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
      ],
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: 'Devstander | High-Standard Software Development Warsaw',
      description:
        'Devstander is a Warsaw-based software development company delivering high-standard web, mobile, and cloud solutions. Full cycle software development, architecture design, and long-term technology partnership.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
    },
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
